import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import qs from 'qs'

export const collection = 'dynamicOptions'

export const schema = new schemas.Array(new schemas.Entity(collection))

type FetchQueryType = {
  serviceKey: string
  accountId: string
  optionsKey: string
  parameters: object
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (
    { serviceKey, accountId, optionsKey, parameters }: FetchQueryType,
    searchTerm = ''
  ) => {
    const baseServiceUrl = `${apiBase}/services/${serviceKey}`
    const extendedApiBase = accountId
      ? `${baseServiceUrl}/accounts/${accountId}`
      : baseServiceUrl
    return callApi(
      `${extendedApiBase}/options/${optionsKey}${qs.stringify(
        { ...parameters, name: searchTerm },
        { addQueryPrefix: true }
      )}`,
      schema
    )
  }
